<template>
    <div class="input-group">
        <v-input
            type="file"
            @change="_onChange"
            v-bind="props"
            ref="input"
        ></v-input>
        <slot name="names">
            <input type="text" class="form-control text-left text-nowrap text-truncate rounded-left" v-if="value" :value="filename" :accept="accept" readonly>
        </slot>
        <slot v-bind="this"></slot>
        <slot name="button">
            <div class="input-group-append">
                <button type="button" class="btn btn-primary" :disabled="disabled" @click="browse" v-if="label" v-html="label"></button>
            </div>
        </slot>
    </div>
</template>

<script>
    import input from '../mixins/input';
    export default {
        name: 'VFile',
        mixins: [
            input,
        ],
        props: {
            name: {
                type: String,
            },
            value: {
                type: String,
            },
            label: {
                type: String,
            },
            disabled: {
                type: Boolean,
            },
            multiple: {
                type: Boolean,
            },
            accept: {
                type: String,
            },
        },
        data() {
            return {
                files: [],
            };
        },
        computed: {
            isNative() {
                return true;
            },
            props() {
                return Object.assign({}, this.$attrs, this.$props)
            },
            filename() {
                if (this.files.length > 0) {
                    return this.files.length > 1
                        ? ("Выбрано файлов: " + this.files.length)
                        : (this.files[0].name || this.value);
                } else {
                    return this.value;
                }
            },
        },
        methods: {
            _onChange(files) {
                this.files = files;
                this.$emit('change', this.files);
            },
            browse() {
                this.$refs.input.$el.click();
            },
        },
    }
</script>

<style scoped>
    input[type="file"] {
        display: none;
    }
</style>